(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dazzle-cart-guest-csv"]) return;
  try {
    
  const cartPage = document.querySelector(".cart-page");

  if (cartPage) {
    const storageKey = "dazzle_guest_order_context_v1";
    const status = cartPage.querySelector("[data-export-status]");
    const downloadButton = cartPage.querySelector("[data-download-order]");
    const buyerCodeWarning = cartPage.querySelector("[data-buyer-code-warning]");
    const saveMessage = cartPage.querySelector("[data-device-save-message]");
    const orderFields = Array.from(cartPage.querySelectorAll("[data-order-field]"));
    const fieldByKey = Object.fromEntries(orderFields.map((field) => [field.dataset.orderField, field]));
    let remoteSaveTimer;

    const getOrderContext = () => {
      return {
        company: fieldByKey.company?.value.trim() || "",
        market: fieldByKey.market?.value.trim() || "",
        buyerCode: fieldByKey.buyerCode?.value.trim() || "",
        contact: fieldByKey.contact?.value.trim() || "",
        email: fieldByKey.email?.value.trim() || "",
        note: fieldByKey.note?.value.trim() || ""
      };
    };

    const setSaveMessage = (message, state = "saved") => {
      if (!saveMessage) return;
      saveMessage.textContent = message;
      saveMessage.classList.toggle("is-saving", state === "saving");
      saveMessage.classList.toggle("is-error", state === "error");
    };

    const saveToDevice = () => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(getOrderContext()));
        setSaveMessage("Selection details saved on this device.");
      } catch (error) {
        setSaveMessage("This browser blocked device storage. Download a draft CSV as a backup.", "error");
      }
    };

    const restoreFromDevice = () => {
      try {
        const savedContext = JSON.parse(localStorage.getItem(storageKey) || "null");
        if (!savedContext) return;

        Object.entries(savedContext).forEach(([key, value]) => {
          const field = fieldByKey[key];
          if (field && !field.value && value) {
            field.value = value;
          }
        });
        setSaveMessage("Previous selection details restored on this device.");
      } catch (error) {
        localStorage.removeItem(storageKey);
      }
    };

    const saveToCart = async () => {
      const context = getOrderContext();
      setSaveMessage("Saving selection details...", "saving");

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            attributes: {
              "Distributor": context.company,
              "Market": context.market,
              "Internal buyer code": context.buyerCode,
              "Buyer contact": context.contact,
              "Buyer email": context.email,
              "Order route": "Guest order request / distributor consolidation",
              "Selection saved on device": "Yes"
            },
            note: context.note
          })
        });

        if (!response.ok) throw new Error("Cart update failed");
        setSaveMessage("Selection details saved on this device and in the current basket.");
      } catch (error) {
        setSaveMessage("Saved on this device. Online basket sync will retry after the next change.", "error");
      }
    };

    const queueSave = () => {
      saveToDevice();
      window.clearTimeout(remoteSaveTimer);
      remoteSaveTimer = window.setTimeout(saveToCart, 650);
    };

    restoreFromDevice();
    orderFields.forEach((field) => field.addEventListener("input", queueSave));
    window.addEventListener("beforeunload", saveToDevice);

    const calculateLinePrice = (unitPrice, quantity, fallback) => {
      const numeric = Number(String(unitPrice).replace(/[^0-9.-]/g, ""));
      const amount = Number(quantity);
      if (!Number.isFinite(numeric) || !Number.isFinite(amount)) {
        return fallback;
      }

      const prefix = String(unitPrice).match(/^[^0-9-]*/)?.[0] || "";
      return `${prefix}${Math.round(numeric * amount).toLocaleString("en-US")}`;
    };

    const getItems = () => Array.from(cartPage.querySelectorAll("[data-order-line]")).map((line, index) => {
      const quantity = line.querySelector("[data-quantity-input]")?.value || "0";
      const url = new URL(line.dataset.url || "/", window.location.origin).href;
      const unitPrice = line.dataset.unitPrice || "";
      return {
        no: index + 1,
        title: line.dataset.title || "",
        sku: line.dataset.sku || "",
        barcode: line.dataset.barcode || line.dataset.sku || "",
        option: line.dataset.option || "",
        quantity,
        unitPrice,
        linePrice: calculateLinePrice(unitPrice, quantity, line.dataset.linePrice || ""),
        url
      };
    });

    const csvValue = (value) => `"${String(value).replace(/"/g, '""')}"`;

    const buildCsv = () => {
      const context = getOrderContext();
      const rows = [
        ["DAZZLE Overseas B2B Order Request"],
        ["Contact name", context.contact],
        ["Company", context.company],
        ["Email", context.email],
        ["Market", context.market],
        ["Order note", context.note],
        [],
        ["No.", "Product", "SKU", "Option", "Quantity", "Reference unit price", "Reference line total", "Product URL"],
        ...getItems()
          .filter((item) => Number(item.quantity) > 0)
          .map((item) => [
            item.no,
            item.title,
            item.sku,
            item.option,
            item.quantity,
            item.unitPrice,
            item.linePrice,
            item.url
          ])
      ];

      return rows.map((row) => row.map(csvValue).join(",")).join("\n");
    };

    const setStatus = (message) => {
      if (status) {
        status.textContent = message;
      }
    };

    const validateStoreDetails = () => {
      const context = getOrderContext();
      if (!context.company) {
        fieldByKey.company?.focus();
        fieldByKey.company?.reportValidity();
        setStatus("Please enter the distributor before continuing.");
        return false;
      }
      return true;
    };

    downloadButton?.addEventListener("click", () => {
      if (!validateStoreDetails()) return;
      const context = getOrderContext();
      if (buyerCodeWarning) {
        buyerCodeWarning.hidden = Boolean(context.buyerCode);
      }
      const blob = new Blob(["\uFEFF" + buildCsv()], { type: "text/csv;charset=utf-8" });
      const link = document.createElement("a");
      const date = new Date().toISOString().slice(0, 10);
      const storeReference = `${context.buyerCode}-${context.company}`
        .replace(/[^a-zA-Z0-9_-]+/g, "-")
        .replace(/^-+|-+$/g, "") || "order";
      link.href = URL.createObjectURL(blob);
      link.download = `DAZZLE-${storeReference}-${date}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);
      saveToDevice();
      setStatus("Order CSV downloaded. Send this file to the distributor for confirmation.");
    });

    cartPage.querySelector(".b2b-cart-form")?.addEventListener("submit", () => {
      saveToDevice();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dazzle-cart"]) return;
  try {
    
  const cartPage = document.querySelector(".cart-page");

  if (cartPage) {
    const storageKey = "dazzle_guest_order_context_v1";
    const status = cartPage.querySelector("[data-export-status]");
    const downloadButton = cartPage.querySelector("[data-download-order]");
    const buyerCodeWarning = cartPage.querySelector("[data-buyer-code-warning]");
    const saveMessage = cartPage.querySelector("[data-device-save-message]");
    const orderFields = Array.from(cartPage.querySelectorAll("[data-order-field]"));
    const fieldByKey = Object.fromEntries(orderFields.map((field) => [field.dataset.orderField, field]));
    let remoteSaveTimer;

    const getOrderContext = () => {
      return {
        company: fieldByKey.company?.value.trim() || "",
        market: fieldByKey.market?.value.trim() || "",
        buyerCode: fieldByKey.buyerCode?.value.trim() || "",
        contact: fieldByKey.contact?.value.trim() || "",
        email: fieldByKey.email?.value.trim() || "",
        note: fieldByKey.note?.value.trim() || ""
      };
    };

    const setSaveMessage = (message, state = "saved") => {
      if (!saveMessage) return;
      saveMessage.textContent = message;
      saveMessage.classList.toggle("is-saving", state === "saving");
      saveMessage.classList.toggle("is-error", state === "error");
    };

    const saveToDevice = () => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(getOrderContext()));
        setSaveMessage("Selection details saved on this device.");
      } catch (error) {
        setSaveMessage("This browser blocked device storage. Download a draft CSV as a backup.", "error");
      }
    };

    const restoreFromDevice = () => {
      try {
        const savedContext = JSON.parse(localStorage.getItem(storageKey) || "null");
        if (!savedContext) return;

        Object.entries(savedContext).forEach(([key, value]) => {
          const field = fieldByKey[key];
          if (field && !field.value && value) {
            field.value = value;
          }
        });
        setSaveMessage("Previous selection details restored on this device.");
      } catch (error) {
        localStorage.removeItem(storageKey);
      }
    };

    const saveToCart = async () => {
      const context = getOrderContext();
      setSaveMessage("Saving selection details...", "saving");

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            attributes: {
              "Distributor": context.company,
              "Market": context.market,
              "Internal buyer code": context.buyerCode,
              "Buyer contact": context.contact,
              "Buyer email": context.email,
              "Order route": "Guest order request / distributor consolidation",
              "Selection saved on device": "Yes"
            },
            note: context.note
          })
        });

        if (!response.ok) throw new Error("Cart update failed");
        setSaveMessage("Selection details saved on this device and in the current basket.");
      } catch (error) {
        setSaveMessage("Saved on this device. Online basket sync will retry after the next change.", "error");
      }
    };

    const queueSave = () => {
      saveToDevice();
      window.clearTimeout(remoteSaveTimer);
      remoteSaveTimer = window.setTimeout(saveToCart, 650);
    };

    restoreFromDevice();
    orderFields.forEach((field) => field.addEventListener("input", queueSave));
    window.addEventListener("beforeunload", saveToDevice);

    const calculateLinePrice = (unitPrice, quantity, fallback) => {
      const numeric = Number(String(unitPrice).replace(/[^0-9.-]/g, ""));
      const amount = Number(quantity);
      if (!Number.isFinite(numeric) || !Number.isFinite(amount)) {
        return fallback;
      }

      const prefix = String(unitPrice).match(/^[^0-9-]*/)?.[0] || "";
      return `${prefix}${Math.round(numeric * amount).toLocaleString("en-US")}`;
    };

    const getItems = () => Array.from(cartPage.querySelectorAll("[data-order-line]")).map((line, index) => {
      const quantity = line.querySelector("[data-quantity-input]")?.value || "0";
      const url = new URL(line.dataset.url || "/", window.location.origin).href;
      const unitPrice = line.dataset.unitPrice || "";
      return {
        no: index + 1,
        title: line.dataset.title || "",
        sku: line.dataset.sku || "",
        barcode: line.dataset.barcode || line.dataset.sku || "",
        option: line.dataset.option || "",
        quantity,
        unitPrice,
        linePrice: calculateLinePrice(unitPrice, quantity, line.dataset.linePrice || ""),
        url
      };
    });

    const csvValue = (value) => `"${String(value).replace(/"/g, '""')}"`;

    const buildCsv = () => {
      const context = getOrderContext();
      const rows = [
        ["DAZZLE Overseas B2B Order Request"],
        ["Contact name", context.contact],
        ["Company", context.company],
        ["Email", context.email],
        ["Market", context.market],
        ["Order note", context.note],
        [],
        ["No.", "Product", "SKU", "Option", "Quantity", "Reference unit price", "Reference line total", "Product URL"],
        ...getItems()
          .filter((item) => Number(item.quantity) > 0)
          .map((item) => [
            item.no,
            item.title,
            item.sku,
            item.option,
            item.quantity,
            item.unitPrice,
            item.linePrice,
            item.url
          ])
      ];

      return rows.map((row) => row.map(csvValue).join(",")).join("\n");
    };

    const setStatus = (message) => {
      if (status) {
        status.textContent = message;
      }
    };

    const validateStoreDetails = () => {
      const context = getOrderContext();
      if (!context.company) {
        fieldByKey.company?.focus();
        fieldByKey.company?.reportValidity();
        setStatus("Please enter the distributor before continuing.");
        return false;
      }
      return true;
    };

    downloadButton?.addEventListener("click", () => {
      if (!validateStoreDetails()) return;
      const context = getOrderContext();
      if (buyerCodeWarning) {
        buyerCodeWarning.hidden = Boolean(context.buyerCode);
      }
      const blob = new Blob(["\uFEFF" + buildCsv()], { type: "text/csv;charset=utf-8" });
      const link = document.createElement("a");
      const date = new Date().toISOString().slice(0, 10);
      const storeReference = `${context.buyerCode}-${context.company}`
        .replace(/[^a-zA-Z0-9_-]+/g, "-")
        .replace(/^-+|-+$/g, "") || "order";
      link.href = URL.createObjectURL(blob);
      link.download = `DAZZLE-${storeReference}-${date}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);
      saveToDevice();
      setStatus("Order CSV downloaded. Send this file to the distributor for confirmation.");
    });

    cartPage.querySelector(".b2b-cart-form")?.addEventListener("submit", () => {
      saveToDevice();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dazzle-order-cart"]) return;
  try {
    
  const cartPage = document.querySelector(".cart-page");

  if (cartPage) {
    const storageKey = "dazzle_guest_order_context_v1";
    const status = cartPage.querySelector("[data-export-status]");
    const downloadButton = cartPage.querySelector("[data-download-order]");
    const buyerCodeWarning = cartPage.querySelector("[data-buyer-code-warning]");
    const saveMessage = cartPage.querySelector("[data-device-save-message]");
    const orderFields = Array.from(cartPage.querySelectorAll("[data-order-field]"));
    const fieldByKey = Object.fromEntries(orderFields.map((field) => [field.dataset.orderField, field]));
    let remoteSaveTimer;

    const getOrderContext = () => {
      return {
        company: fieldByKey.company?.value.trim() || "",
        market: fieldByKey.market?.value.trim() || "",
        buyerCode: fieldByKey.buyerCode?.value.trim() || "",
        contact: fieldByKey.contact?.value.trim() || "",
        email: fieldByKey.email?.value.trim() || "",
        note: fieldByKey.note?.value.trim() || ""
      };
    };

    const setSaveMessage = (message, state = "saved") => {
      if (!saveMessage) return;
      saveMessage.textContent = message;
      saveMessage.classList.toggle("is-saving", state === "saving");
      saveMessage.classList.toggle("is-error", state === "error");
    };

    const saveToDevice = () => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(getOrderContext()));
        setSaveMessage("Selection details saved on this device.");
      } catch (error) {
        setSaveMessage("This browser blocked device storage. Download a draft CSV as a backup.", "error");
      }
    };

    const restoreFromDevice = () => {
      try {
        const savedContext = JSON.parse(localStorage.getItem(storageKey) || "null");
        if (!savedContext) return;

        Object.entries(savedContext).forEach(([key, value]) => {
          const field = fieldByKey[key];
          if (field && !field.value && value) {
            field.value = value;
          }
        });
        setSaveMessage("Previous selection details restored on this device.");
      } catch (error) {
        localStorage.removeItem(storageKey);
      }
    };

    const saveToCart = async () => {
      const context = getOrderContext();
      setSaveMessage("Saving selection details...", "saving");

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            attributes: {
              "Distributor": context.company,
              "Market": context.market,
              "Internal buyer code": context.buyerCode,
              "Buyer contact": context.contact,
              "Buyer email": context.email,
              "Order route": "Guest order request / distributor consolidation",
              "Selection saved on device": "Yes"
            },
            note: context.note
          })
        });

        if (!response.ok) throw new Error("Cart update failed");
        setSaveMessage("Selection details saved on this device and in the current basket.");
      } catch (error) {
        setSaveMessage("Saved on this device. Online basket sync will retry after the next change.", "error");
      }
    };

    const queueSave = () => {
      saveToDevice();
      window.clearTimeout(remoteSaveTimer);
      remoteSaveTimer = window.setTimeout(saveToCart, 650);
    };

    restoreFromDevice();
    orderFields.forEach((field) => field.addEventListener("input", queueSave));
    window.addEventListener("beforeunload", saveToDevice);

    const calculateLinePrice = (unitPrice, quantity, fallback) => {
      const numeric = Number(String(unitPrice).replace(/[^0-9.-]/g, ""));
      const amount = Number(quantity);
      if (!Number.isFinite(numeric) || !Number.isFinite(amount)) {
        return fallback;
      }

      const prefix = String(unitPrice).match(/^[^0-9-]*/)?.[0] || "";
      return `${prefix}${Math.round(numeric * amount).toLocaleString("en-US")}`;
    };

    const getItems = () => Array.from(cartPage.querySelectorAll("[data-order-line]")).map((line, index) => {
      const quantity = line.querySelector("[data-quantity-input]")?.value || "0";
      const url = new URL(line.dataset.url || "/", window.location.origin).href;
      const unitPrice = line.dataset.unitPrice || "";
      return {
        no: index + 1,
        title: line.dataset.title || "",
        sku: line.dataset.sku || "",
        barcode: line.dataset.barcode || line.dataset.sku || "",
        option: line.dataset.option || "",
        quantity,
        unitPrice,
        linePrice: calculateLinePrice(unitPrice, quantity, line.dataset.linePrice || ""),
        url
      };
    });

    const csvValue = (value) => `"${String(value).replace(/"/g, '""')}"`;

    const buildCsv = () => {
      const context = getOrderContext();
      const rows = [
        ["DAZZLE Overseas B2B Order Request"],
        ["Contact name", context.contact],
        ["Company", context.company],
        ["Email", context.email],
        ["Market", context.market],
        ["Order note", context.note],
        [],
        ["No.", "Product", "SKU", "Option", "Quantity", "Reference unit price", "Reference line total", "Product URL"],
        ...getItems()
          .filter((item) => Number(item.quantity) > 0)
          .map((item) => [
            item.no,
            item.title,
            item.sku,
            item.option,
            item.quantity,
            item.unitPrice,
            item.linePrice,
            item.url
          ])
      ];

      return rows.map((row) => row.map(csvValue).join(",")).join("\n");
    };

    const setStatus = (message) => {
      if (status) {
        status.textContent = message;
      }
    };

    const validateStoreDetails = () => {
      const context = getOrderContext();
      if (!context.company) {
        fieldByKey.company?.focus();
        fieldByKey.company?.reportValidity();
        setStatus("Please enter the distributor before continuing.");
        return false;
      }
      return true;
    };

    downloadButton?.addEventListener("click", () => {
      if (!validateStoreDetails()) return;
      const context = getOrderContext();
      if (buyerCodeWarning) {
        buyerCodeWarning.hidden = Boolean(context.buyerCode);
      }
      const blob = new Blob(["\uFEFF" + buildCsv()], { type: "text/csv;charset=utf-8" });
      const link = document.createElement("a");
      const date = new Date().toISOString().slice(0, 10);
      const storeReference = `${context.buyerCode}-${context.company}`
        .replace(/[^a-zA-Z0-9_-]+/g, "-")
        .replace(/^-+|-+$/g, "") || "order";
      link.href = URL.createObjectURL(blob);
      link.download = `DAZZLE-${storeReference}-${date}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);
      saveToDevice();
      setStatus("Order CSV downloaded. Send this file to the distributor for confirmation.");
    });

    cartPage.querySelector(".b2b-cart-form")?.addEventListener("submit", () => {
      saveToDevice();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dazzle-product-detail"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-detail]');

    roots.forEach((root) => {
      const mainImage = root.querySelector('[data-main-image]');
      const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
      const previousButton = root.querySelector('[data-gallery-previous]');
      const nextButton = root.querySelector('[data-gallery-next]');
      let activeImageIndex = 0;

      const setImage = (index) => {
        if (!mainImage || thumbs.length === 0) return;
        activeImageIndex = (index + thumbs.length) % thumbs.length;
        const selectedThumb = thumbs[activeImageIndex];
        const fullImage = selectedThumb.dataset.full;

        if (fullImage) {
          mainImage.src = fullImage;
          mainImage.removeAttribute('srcset');
        }

        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        selectedThumb.classList.add('is-active');
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => setImage(index));
      });

      if (previousButton) {
        previousButton.addEventListener('click', () => setImage(activeImageIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => setImage(activeImageIndex + 1));
      }

      const variantJson = root.querySelector('[data-variant-json]');
      if (!variantJson) return;

      let variants = [];

      try {
        variants = JSON.parse(variantJson.textContent);
      } catch (error) {
        variants = [];
      }

      const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));
      const variantIdInput = root.querySelector('[data-selected-variant-id]');
      const addButton = root.querySelector('[data-add-button]');
      const skuNode = root.querySelector('[data-product-sku]');
      const styleCodeNode = root.querySelector('[data-style-code]');
      const colorCodeNode = root.querySelector('[data-color-code]');
      const sizeCodeNode = root.querySelector('[data-size-code]');

      const getSelectedOptions = () => {
        const selected = [];

        optionInputs.forEach((input) => {
          if (!input.checked) return;
          selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });

        return selected;
      };

      const findVariant = () => {
        const selected = getSelectedOptions();

        return variants.find((variant) => {
          if (!variant.options) return false;

          return variant.options.every((option, index) => option === selected[index]);
        });
      };

      const updateCodes = (variant) => {
        if (!variant) return;
        const code = variant.barcode || variant.sku || '';

        if (skuNode) skuNode.textContent = variant.sku || code;
        if (styleCodeNode) styleCodeNode.textContent = code.slice(0, 7);
        if (colorCodeNode) colorCodeNode.textContent = code.slice(7, 9);
        if (sizeCodeNode) sizeCodeNode.textContent = code.slice(9, 11);
      };

      const updateSelectedLabels = () => {
        optionInputs.forEach((input) => {
          if (!input.checked) return;
          const label = root.querySelector(`[data-option-selected="${input.dataset.optionPosition}"]`);
          if (label) label.textContent = input.value;
        });
      };

      const updateVariant = () => {
        const variant = findVariant();
        updateSelectedLabels();

        if (!variant) {
          if (addButton) addButton.disabled = true;
          return;
        }

        if (variantIdInput) variantIdInput.value = variant.id;
        if (addButton) addButton.disabled = !variant.available;
        updateCodes(variant);

        if (variant.featured_image && variant.featured_image.src && mainImage) {
          mainImage.src = variant.featured_image.src;
          mainImage.removeAttribute('srcset');
        }
      };

      optionInputs.forEach((input) => {
        input.addEventListener('change', updateVariant);
      });

      const productForm = root.querySelector(".product-purchase-form");
      const addStatus = root.querySelector("[data-add-status]");

      const setAddStatus = (message, state = "success") => {
        if (!addStatus) return;
        addStatus.textContent = message;
        if (message) addStatus.dataset.state = state;
        if (!message) addStatus.removeAttribute("data-state");
      };

      productForm?.addEventListener("submit", async (event) => {
        event.preventDefault();

        const originalLabel = addButton?.textContent;
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = "Adding...";
        }
        setAddStatus("");

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
            method: "POST",
            body: new FormData(productForm),
            headers: {
              Accept: "application/json"
            }
          });

          if (!response.ok) {
            throw new Error("Unable to add product to cart.");
          }

          if (addButton) addButton.textContent = "Added to order basket";
          setAddStatus("Added to order basket. You can continue selecting styles or open Cart when ready.");
        } catch (error) {
          setAddStatus("Unable to add this item. Please check the selected size and try again.", "error");
        } finally {
          window.setTimeout(() => {
            if (addButton) {
              addButton.disabled = false;
              addButton.textContent = originalLabel;
            }
          }, 1400);
        }
      });

      updateVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
